import {
  Button,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  Icon,
  Input,
} from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PersonIcon from "../../plugin/components/common/icons/PersonIcon";

const VictimForm = ({ register, errors }) => {
  const { t } = useTranslation();

  return (
    <Grid
      gap={"8px"}
      templateColumns={{ base: "repeat(1, 1fr)", xl: "repeat(7, 1fr)" }}
      templateRows={{ base: "repeat(1, 1fr)", xl: "repeat(1, 1fr)" }}
    >
      <GridItem colSpan={7} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"ssn"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.ssn.title</Trans>
          </FormLabel>
          <Input
            id={"ssn"}
            placeholder={t("beneficiaryFile.form.ssn.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("ssn")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"victimGender"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.gender.title</Trans>
          </FormLabel>
          <Input
            id={"victimGender"}
            placeholder={t("beneficiaryFile.form.gender.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("victimGender")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={3} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"victimLastName"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.lastName.title</Trans>
          </FormLabel>
          <Input
            id={"victimLastName"}
            placeholder={t("beneficiaryFile.form.lastName.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("victimLastName")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={3} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"victimFirstName"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.firstName.title</Trans>
          </FormLabel>
          <Input
            id={"victimFirstName"}
            placeholder={t("beneficiaryFile.form.firstName.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("victimFirstName")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={4} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"birthdate"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.birthdate.title</Trans>
          </FormLabel>
          <Input id={"birthdate"} type={"date"} style={{ colorScheme: "dark" }} backgroundColor={"#2D313A"} {...register("birthdate")} />
        </FormControl>
      </GridItem>
      <GridItem colSpan={3} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"weight"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.weight.title</Trans>
          </FormLabel>
          <Input
            id={"weight"}
            placeholder={t("beneficiaryFile.form.weight.placeholder")}
            type={"number"} style={{ colorScheme: "dark" }}
            backgroundColor={"#2D313A"}
            {...register("weight")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={7} rowSpan={1}>
        <HStack>
          <Button size={"sm"} colorScheme="whiteAlpha"><Icon as={PersonIcon} marginRight={"8px"} /><Trans>beneficiaryFile.form.victim</Trans> 1</Button>
          <Button size={"sm"} colorScheme="whiteAlpha" variant={"outline"}><Icon as={PersonIcon} marginRight={"8px"} /><Trans>beneficiaryFile.form.victim</Trans> 2</Button>
          <Button size={"sm"} colorScheme="whiteAlpha" variant={"outline"}><Icon as={PersonIcon} marginRight={"8px"} /><Trans>beneficiaryFile.form.victim</Trans> 3</Button>
          <Button size={"sm"} colorScheme="whiteAlpha" variant={"outline"}><Icon as={PersonIcon} marginRight={"8px"} /><Trans>beneficiaryFile.form.victim</Trans> 4</Button>
          <Button size={"sm"} colorScheme="whiteAlpha" variant={"outline"}><Icon as={PersonIcon} marginRight={"8px"} /><Trans>beneficiaryFile.form.victim_new</Trans></Button>
        </HStack>
      </GridItem>
    </Grid>
  );
};

export default VictimForm;
